export default __webpack_public_path__ + "static/media/location_error.1457023f.svg";